module.exports = __webpack_public_path__ + "static/sales-team-inbox-c409999f525f5053fcf772042f50435c.png";